import api from 'services/api';

export type NotificationProps = {
  uuid?: string;
  title: string;
  message: string;
  mobileUserUuid?: string;
  organizationUuid?: string[];
};

const findAllNotifications = async () => {
  const response = await api.get<NotificationProps[]>('/apiv1/notifications/all/');
  return response?.data;
};

const createBroadcast = async (newBroadcast: NotificationProps) => {
  const response = await api.post<NotificationProps>('/apiv1/broadcast/', newBroadcast);
  return response?.data;
};

const createNotification = async (newNotification: NotificationProps) => {
  const response = await api.post<NotificationProps>('/apiv1/notification/', newNotification);
  return response?.data;
};

const updateNotification = async (
  uuid: string | undefined,
  updatedNotification: NotificationProps
) => {
  const response = await api.put<NotificationProps>(
    `/apiv1/notification/${uuid}/`,
    updatedNotification
  );
  return response?.data;
};

const NotificationService = {
  findAllNotifications,
  createBroadcast,
  createNotification,
  updateNotification
};

export default NotificationService;
